import { Backdrop, IconButton, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import React, { useState } from 'react';
import { PuffLoader } from 'react-spinners';
import { IAllTemplateList } from '../../../models/Admin/ClientPlacements/IAllTemplateList';
import { useDelete } from '../../../utils/apiHelper';
import { Transition } from '../../GlobalStyles/DialogBoxTransition';
import { DialogTitleDelete } from '../../GlobalStyles/DialogStyle';
import { useStyles } from './ClientPlacementOptionsCss';

const DeleteTemplate: React.FC<{ templateRow: IAllTemplateList, onDelete: () => void }> = (props) => {
  const { templateRow } = props;
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const [ProgressBar, setShowProgressBar] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOk = () => {
    setShowProgressBar(true);
    useDelete("File/DeleteMultipleFile?PlacementTemplateId=" + templateRow?.placement_template_id);
    useDelete("ClientPlacement/DeleteTemplate?placement_template_id=" + templateRow.placement_template_id).then((r) => {
      props.onDelete();
    }).finally(() => {
      setShowProgressBar(false);
    });
  }

  return (
    <React.Fragment>
      <div>
        <IconButton id="CPO_Delete_btn" aria-label="delete" className={classes.deleteBtn} onClick={handleClickOpen} disabled={templateRow.placement_template_id === 1 || props?.templateRow?.canDelete ? true : false}>
          <DeleteForeverIcon className={templateRow.placement_template_id === 1 || props?.templateRow?.canDelete ? classes.deleteDisable : classes.deleteEnable} />
        </IconButton>
        <Backdrop className={classes.backdrop} open={ProgressBar}>
          <PuffLoader size={80} color={"white"} speedMultiplier={1} />
        </Backdrop>
        <Dialog
          PaperProps={{ style: { borderRadius: 10 } }}
          open={open}
          maxWidth={"xs"}
          onClose={handleClose}
          TransitionComponent={Transition}
          aria-labelledby="responsive-dialog-title" >
          <DialogTitleDelete id="responsive-dialog-title" onClose={handleClose}>
            <Typography variant="h6" gutterBottom className={classes.title}>
              DELETE TEMPLATE
            </Typography>
          </DialogTitleDelete>
          <DialogContent>
            <Typography variant="h6" className={classes.titleConfirm} gutterBottom>
              Are you sure, you want to delete this Template ?
            </Typography>
          </DialogContent>
          <DialogActions >
            <Button id="CPO_OK_btn" size="small" onClick={() => { handleClose(); handleOk(); }} color="primary" className={classes.yesButton} autoFocus>
              Yes
            </Button>
            <Button id="CPO_Cancel_btn" size="small" color="primary" className={classes.noButton} autoFocus onClick={handleClose} variant="contained">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>

    </React.Fragment>
  );
}

export default DeleteTemplate